import { useCallback } from 'react';
import api from "../../services/api";

const useUsers = () => {
  const findAll = useCallback(async () => {
    const { data } = await api.get("/users");
    return data;
  }, []);

  return { findAll };
};

export default useUsers;
